import { GenderDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { Gender } from '@/services/graphql/types';

export const mapperGenderDataEnum = createEnumMapperFunction(
  Gender,
  GenderDataEnum
);
